import { ENTYC4 } from "./CGUTranslation";
import { ENTYC3 } from "./PPDTranslation";
import { EN1 } from "./translations1";
import { EN2 } from "./translations2";
import { ENTYC1 } from "./TycsTranslation1";
import { ENTYC2 } from "./TycsTranslation2";

const EN = { ...EN1, ...EN2, ...ENTYC1, ...ENTYC2, ...ENTYC3, ...ENTYC4 };
export { EN };